import { useEffect, useRef } from 'react';
import { useGlobalStore } from '@/stores';
import { AddContactFlow, type AddContactFlowRef, CustomersTable, ImportProgressBanner } from '@/features/customers';
import { StanButton } from '@/components';

export default function CustomersPage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);
    const addContactFlowRef = useRef<AddContactFlowRef>(null);

    useEffect(() => {
        setBreadcrumbs([{ title: 'My Customers', to: '/audience', active: true, id: 'customers' }]);
    }, [setBreadcrumbs]);

    const handleAddContactClick = () => {
        addContactFlowRef.current?.open();
    };

    return (
        <div className='flex w-full flex-col gap-6'>
            <ImportProgressBanner />
            <div className='flex items-center justify-end'>
                <StanButton
                    name='add-contacts-button'
                    size='xs'
                    color='primary'
                    variant='outline'
                    onClick={handleAddContactClick}
                >
                    Add Contacts
                </StanButton>
            </div>
            <CustomersTable />
            <AddContactFlow ref={addContactFlowRef} />
        </div>
    );
}
